'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { pushPageView } from '@/lib/analytics/funnel-events'

/**
 * Pushes `page_view` on every client-side navigation
 * (marketing/conversion-events/site-tracking-contract.md section 5.3). App
 * Router navigations never fire the container's `gtm.js` event again, so the
 * number-swap and click-tracker tags have nothing to re-run on; this is the
 * event their `page_view` trigger listens for.
 *
 * The first render is skipped: the container's own initial page view already
 * covers the landing page. Kept out of providers.tsx so a pathname change
 * re-renders this leaf alone and not the whole provider tree.
 */
export function PageViewTracker() {
  const pathname = usePathname()
  const first = useRef(true)

  useEffect(() => {
    if (first.current) {
      first.current = false
      return
    }
    pushPageView(pathname)
  }, [pathname])

  return null
}

export default PageViewTracker
